/**
 * @description: 用户管理路由文件
 * @author: lx
 * @Compile：2022-06-02 10：00
 * @update: lx(2022-06-02 10：00)
 */
export default [
  {
    path: "/globalconfig",
    component: () => import("../pages/globalconfig/globalconfig.vue"),
    name: "globalconfig",
    title: "系统参数配置",
    meta: {
      title: "系统参数配置"
    }
  },
  {
    path: "/welcomeManage",
    component: () => import("../pages/lookfor/welcome/welcome.vue"),
    name: "welcomeManage",
    title: "开屏页管理",
    meta: {
      title: "开屏页管理"
    }
  },
  {
    path: "/globalCategory",
    component: () => import("../pages/base/globalCategoryManage.vue"),
    name: "globalCategory",
    title: "全局类型管理",
    meta: {
      title: "全局类型管理"
    }
  },
]
